import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Undo"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.25 11.25C19.125 11.25 20.25 12.375 20.25 14.25C20.25 16.125 19.125 17.25 17.25 17.25H13.5V18.75H17.25C19.875 18.75 21.75 16.875 21.75 14.25C21.75 11.625 19.875 9.74995 17.25 9.74995H5.1L8.1 6.74995L7.05 5.69995L2.25 10.5L7.05 15.3L8.1 14.25L5.1 11.25H17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Undo.vue"]]);
